import React, { useState, useEffect } from "react";
import { DashboardLayout } from "@layouts/DashboardLayout";
import { Requests } from ".";
import { getProfile } from "@services/krent.service";

const AllRequests = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    getProfile(controller.signal)
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching profile:", err);
        setLoading(false);
      });

    return () => controller.abort();
  }, []);

  if (loading)
    return (
      <DashboardLayout
        title="Requests"
        subtitle="Manage all requests on your property"
      >
        <div>Loading...</div>
      </DashboardLayout>
    );

  return (
    <DashboardLayout
      title="Requests"
      subtitle="Manage all requests on your property"
    >
      <Requests />
    </DashboardLayout>
  );
};

export default AllRequests;
